import { getAccessToken } from "../lib/auth";
import { parseApiError } from "../lib/api-error";

export interface AccessMatrixUser {
  id: string;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface AccessMatrixRow {
  user: AccessMatrixUser;
  access: Record<string, { roles: string[]; orgUnitTypes: string[] }>;
}

export interface AccessMatrixResponse {
  rows: AccessMatrixRow[];
  total: number;
  apps: string[];
}

async function fetchAccessAPI<T>(endpoint: string): Promise<T> {
  const token = await getAccessToken();
  const response = await fetch(`/api/access${endpoint}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw await parseApiError(response);
  }

  return response.json();
}

export const accessMatrixApi = {
  getMatrix: (params?: { first?: number; max?: number; search?: string }) => {
    const qs = new URLSearchParams();
    if (params?.first !== undefined) qs.set("first", String(params.first));
    if (params?.max !== undefined) qs.set("max", String(params.max));
    if (params?.search) qs.set("search", params.search);
    const query = qs.toString();
    return fetchAccessAPI<AccessMatrixResponse>(`/matrix${query ? `?${query}` : ""}`);
  },
};
